import React from 'react';
import { FormControlLabel, Switch } from '@mui/material';

interface SwitchMenuItemProps {
  label: string;
  checked?: boolean;
  onChange(checked: boolean): void;
}

export const SwitchMenuItem = ({ label, checked, onChange, }: SwitchMenuItemProps) => {
  const handleChange = (event: React.SyntheticEvent, checked: boolean) => {
    onChange(checked);
  };

  return (
    <FormControlLabel
      labelPlacement="start"
      control={<Switch checked={checked} onChange={handleChange} inputProps={{ style: { position: 'absolute' } }} />}
      label={label}
      componentsProps={{ typography: { sx: { padding: 0.5 } } }}
      sx={{ justifyContent: 'space-between' }}
    />
  );
};
